import React, { useEffect, useState } from 'react';
import { BOAPI } from "../service/UsersService";

const DonationsTab = () => {
  const [deposits, setDeposits] = useState({ totalToday: 0, totalWeek: 0, countToday: 0, countWeek: 0 });
  const [credit, setCredit]     = useState({ creditToday: 0, creditWeek: 0, creditCountToday: 0, creditCountWeek: 0 });
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [lastRefresh, setLastRefresh] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await BOAPI.fetchDonationsSummary();
      if (res?.[0]?.[0]?.code === 0) {
        setDeposits(res[1]?.[0] || {});
        setCredit(res[2]?.[0] || {});
        setLastRefresh(new Date());
      } else {
        setError(res?.[0]?.[0]?.msg || 'שגיאה בטעינת הנתונים');
      }
    } catch (e) {
      setError(e.message || 'שגיאה בטעינת הנתונים');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const fmt = (n) => (Number(n) || 0).toLocaleString('he-IL');

  if (loading) return <div style={s.center}>טוען נתוני צדקה...</div>;

  return (
    <div style={s.container}>
      <div style={s.headerRow}>
        <h2 style={s.title}>ניהול צדקה</h2>
        <button style={s.refreshBtn} onClick={load}>🔄 רענן</button>
      </div>

      {lastRefresh && (
        <div style={s.lastUpdate}>
          עודכן לאחרונה: {lastRefresh.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
        </div>
      )}

      {error && (
        <div style={s.errorBanner}>
          ❌ {error}
          <button style={s.closeErr} onClick={() => setError(null)}>✕</button>
        </div>
      )}

      {/* כרטיסי סיכום */}
      <div style={s.grid}>

        {/* סה"כ לקופות */}
        <div style={s.card}>
          <div style={s.cardIcon}>💵</div>
          <div style={s.cardContent}>
            <div style={s.cardTitle}>סה"כ נכנס לקופות</div>
            <div style={s.mainRow}>
              <span style={s.periodLabel}>היום</span>
              <span style={{ ...s.bigNum, color: '#2e7d32' }}>₪{fmt(deposits.totalToday)}</span>
            </div>
            <div style={s.divider} />
            <div style={s.subRow}>
              <span style={s.subLabel}>מתחילת השבוע</span>
              <span style={s.subNum}>₪{fmt(deposits.totalWeek)}</span>
            </div>
            <div style={s.countRow}>
              <span style={s.countBadge}>היום: {deposits.countToday || 0} הפקדות</span>
              <span style={s.countBadge}>שבוע: {deposits.countWeek || 0} הפקדות</span>
            </div>
          </div>
        </div>

        {/* תשלום באשראי */}
        <div style={s.card}>
          <div style={s.cardIcon}>💳</div>
          <div style={s.cardContent}>
            <div style={s.cardTitle}>שולם באשראי</div>
            <div style={s.mainRow}>
              <span style={s.periodLabel}>היום</span>
              <span style={{ ...s.bigNum, color: '#1f6feb' }}>₪{fmt(credit.creditToday)}</span>
            </div>
            <div style={s.divider} />
            <div style={s.subRow}>
              <span style={s.subLabel}>מתחילת השבוע</span>
              <span style={s.subNum}>₪{fmt(credit.creditWeek)}</span>
            </div>
            <div style={s.countRow}>
              <span style={s.countBadge}>היום: {credit.creditCountToday || 0} עסקאות</span>
              <span style={s.countBadge}>שבוע: {credit.creditCountWeek || 0} עסקאות</span>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
};

const s = {
  container:  { padding: 20, direction: 'rtl', fontFamily: 'Arial, sans-serif' },
  center:     { padding: 40, textAlign: 'center', color: '#999' },
  headerRow:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 6 },
  title:      { margin: 0, color: '#1a1f36', fontSize: 24, fontWeight: 'bold' },
  refreshBtn: { padding: '8px 16px', background: '#fff', border: '1.5px solid #e3e8ee', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 },
  lastUpdate: { color: '#a3acb9', fontSize: 12, marginBottom: 20 },
  errorBanner:{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#ffebee', color: '#c62828', padding: 14, borderRadius: 6, marginBottom: 16 },
  closeErr:   { background: 'transparent', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: 18, fontWeight: 'bold' },

  grid:       { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 },
  card:       { background: '#fff', borderRadius: 16, border: '1px solid #e3e8ee', boxShadow: '0 4px 16px rgba(0,0,0,0.04)', padding: 24, display: 'flex', gap: 16, alignItems: 'flex-start' },
  cardIcon:   { fontSize: 32, flexShrink: 0, marginTop: 2 },
  cardContent:{ flex: 1 },
  cardTitle:  { fontSize: 15, fontWeight: 700, color: '#1a1f36', marginBottom: 14, borderBottom: '2px solid #f4f6f8', paddingBottom: 10 },
  mainRow:    { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 },
  periodLabel:{ fontSize: 14, color: '#4f566b', fontWeight: 600 },
  bigNum:     { fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px' },
  divider:    { height: 1, background: '#f4f6f8', margin: '8px 0' },
  subRow:     { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 },
  subLabel:   { fontSize: 13, color: '#697386' },
  subNum:     { fontSize: 17, fontWeight: 700, color: '#4f566b' },
  countRow:   { display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 },
  countBadge: { background: '#f0f4ff', color: '#1f6feb', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 600 },
};

export default DonationsTab;
